export function isUndefinedOrNull(value: unknown) {
  return value === undefined || value === null;
}
